export const API_PORT_FOR_E2E = '$PLACEHOLDER';